// Left-menu definition for every standalone module. Paths are relative to /m/<module>.
const std = (extra = []) => [
  { label: "REPORTS & DATA", items: [["reports", "Standard reports"], ["report-builder", "DIY report builder"], ["customer", "Customer lookup"]] },
  { label: "CONFIGURATION", items: [["rules", "DIY rules"], ...extra] },
];

export const MODULE_NAV = {
  calling: [
    { label: "OVERVIEW", items: [["", "Dashboard", true]] },
    { label: "LEADS", items: [["pipeline", "Lead pipeline"], ["tasks", "Task list"], ["new", "New lead / bulk import"], ["sources", "Lead sources"]] },
    { label: "ACTIVITY", items: [["calls", "Call log"], ["agents", "Agent board"], ["tickets", "Tickets from calls"]] },
    { label: "APPOINTMENTS", items: [["appointments", "Appointments"]] },
    ...std(),
  ],
  feedback: [
    { label: "OVERVIEW", items: [["", "Dashboard", true], ["nps-dashboard", "NPS analytics"]] },
    { label: "SURVEYS", items: [["surveys", "All surveys"], ["surveys/new", "New survey"]] },
    { label: "DISTRIBUTION", items: [["broadcast", "Broadcast survey"], ["triggers", "Auto-triggers"], ["invites", "Invites & delivery"]] },
    { label: "RESPONSES", items: [["responses", "Response inbox"], ["nps-inbox", "Legacy NPS inbox"]] },
    { label: "SERVICE RECOVERY", items: [["detractors", "Detractor tickets"], ["tickets", "All tickets"]] },
    ...std(),
  ],
  rewards: [
    { label: "OVERVIEW", items: [["", "Dashboard", true]] },
    { label: "CHOOSE YOUR REWARD", items: [["funnel", "Funnel & sessions"], ["coupons", "Issued coupons"], ["redeem", "POS redemption"]] },
    ...std([["/cyr", "Public CYR page ↗"]]),
  ],
  referrals: [
    { label: "OVERVIEW", items: [["", "Dashboard", true]] },
    { label: "STYLO", items: [["referrals", "Referrals & ambassadors"]] },
    ...std(),
  ],
  receipts: [
    { label: "OVERVIEW", items: [["", "Dashboard", true]] },
    { label: "RECEIPTS", items: [["log", "Send log & resend"], ["cta", "CTA click analytics"]] },
    { label: "DESIGN", items: [["template", "Template designer"]] },
    ...std(),
  ],
  appointments: [
    { label: "OVERVIEW", items: [["", "Dashboard", true]] },
    { label: "APPOINTMENTS", items: [["appointments", "Book & manage"]] },
    ...std(),
  ],
  ecommerce: [
    { label: "OVERVIEW", items: [["", "Dashboard", true]] },
    { label: "COMMERCE", items: [["commerce", "Reservations & orders"]] },
    ...std(),
  ],
  vouchers: [
    { label: "OVERVIEW", items: [["", "Dashboard", true]] },
    { label: "VOUCHERS", items: [["commerce", "Issue & redeem"]] },
    ...std(),
  ],
  marketing: [
    { label: "OVERVIEW", items: [["", "Dashboard", true]] },
    { label: "AUTOMATION", items: [["journeys", "Journeys"], ["auto-campaigns", "Auto campaigns"], ["events", "Event bus"]] },
    { label: "CAMPAIGNS", items: [["campaigns", "Campaigns"], ["segments", "Segment builder"], ["growth", "Growth hub · CTWA · A/B"]] },
    { label: "MESSAGING", items: [["templates", "Templates"], ["message-log", "Message log"], ["bulk-jobs", "Bulk send jobs"], ["provider-settings", "Provider settings"]] },
    ...std(),
  ],
  consent: [
    { label: "OVERVIEW", items: [["", "Dashboard", true]] },
    { label: "CONSENT", items: [["consent", "Consent ledger & suppression"]] },
    ...std(),
  ],
  customer360: [
    { label: "OVERVIEW", items: [["", "Dashboard", true]] },
    { label: "CUSTOMERS", items: [["profile", "Profile & timeline"], ["customers", "Customer directory"], ["identity", "Identity & merges"]] },
    { label: "SUPPORT DESK", items: [["support-desk/search-redeem-points-otp", "Redeem points OTP"], ["support-desk/search-redeem-coupon-otp", "Redeem coupon OTP"], ["support-desk/reactivate-coupon", "Reactivate coupon"], ["support-desk/reactivate-redeem-points", "Reactivate redeem points"], ["support-desk/customer-deactivate", "Deactivate customer"], ["support-desk/customer-reactivate", "Reactivate customer"], ["support-desk/update-mobile", "Update mobile"], ["support-desk/unsubscribe", "Unsubscribe"], ["support-desk/audit-log", "Support audit"]] },
    ...std(),
  ],
  integrations: [
    { label: "OVERVIEW", items: [["", "Dashboard", true]] },
    { label: "ADAPTERS", items: [["hub", "Integration hub"], ["api-monitor", "API monitor"], ["pos-credentials", "POS credentials"], ["events", "Event bus"]] },
    ...std(),
  ],
  control: [
    { label: "OVERVIEW", items: [["", "Dashboard", true]] },
    { label: "GOVERNANCE", items: [["objects", "Config objects"], ["access", "Access control & MFA"], ["users", "User management"]] },
    ...std(),
  ],
};
